    <div class="Numpad">
      <div class="calculator">
        <div class="keys" (click)="send('7')">7</div>
        <div class="keys" (click)="send('8')">8</div>
        <div class="keys" (click)="send('9')">9</div>
        <div class="keys darker" (click)="deleteOne()">
          <img class="svg" src="assets/img/numpad-back.svg" alt="icono back">
        </div>
        <div class="keys" (click)="send('4')">4</div>
        <div class="keys" (click)="send('5')">5</div>
        <div class="keys" (click)="send('6')">6</div>
        <div class="keys darker" (click)="setToBlank()">
          <img class="svg" src="assets/img/numpad-x.svg" alt="icono x">
        </div>
        <div id="anomaly-keys-wrapper">
          <div>
            <div class="keys" (click)="send('1')">1</div>
            <div class="keys" (click)="send('2')">2</div>
            <div class="keys" (click)="send('3')">3</div>
            <div class="keys" (click)="send('0')">0</div>
            <div class="keys" (click)="send('-')">-</div>
            <div class="keys" (click)="send(',')">,</div>
          </div>
          <div (click)="acceptChanges()">
            <div class="keys tall darker">
              <img class="svg" src="assets/img/numpad-enter.svg" alt="icono enter">
            </div>
          </div>
        </div>
      </div>
    </div>

  
